import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MarketplaceItem} from '@webmate-web-core/shared/types/marketplace';

@Component({
    selector: 'wm-marketplace-card',
    templateUrl: './marketplace-card.component.html',
    styleUrls: ['./marketplace-card.component.less']
})
export class MarketplaceCardComponent {

    @Input({required: true}) item: MarketplaceItem;
    @Input() pricingVisible = false;
    @Input() primaryActionDisabled = false;
    @Input() primaryActionLabel?: string;
    @Output() detail = new EventEmitter<MarketplaceItem>();
    @Output() action = new EventEmitter<MarketplaceItem>();

    get actionLabel(): string {
        return this.primaryActionLabel || this.item.primaryAction.label;
    }

    openDetails(): void {
        this.detail.emit(this.item);
    }

    runAction(): void {
        this.action.emit(this.item);
    }
}
